<template>
    <FormCard>
        <template #cardTitle>
            Search Requesting Hospital/Clinic and Doctor
        </template>
        <template #cardSubtitle>
            Please fill out the necessary information about the healthcare provider. The dropdown fields will only show providers THAT YOU HAVE AN ACCESS. If you cannot find the one that you are looking for, please contact HMI.
        </template>
        <template #cardText>
            <v-alert
                color="teal darken-4"
                outlined
                style="margin: 5px 0 0 0"
                type="info"
            >
                <span><strong>Disclaimer: </strong>The accreditation status of each facility and doctor may change before updates are reflected in this list.</span>
            </v-alert>
            <v-card style="padding: 10px 20px; margin-top: 5px" class="elevation-10">
                <ReqFilterHosp
                    :req="req"
                    :member_model="member_model"
                    :loading="loading"
                />
                <v-expand-transition>
                    <v-row no-gutters>
                        <v-col
                            cols="12"
                            sm="4"
                            :style="`paddingRight: ${screen_width >= 600 ? '5px' : 0}`"
                        >
                            <ReqRegion
                                :req="req"
                                :member_model="member_model"
                                :loading="loading"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            sm="4"
                            :style="`padding: ${screen_width >= 600 ? '0 5px' : 0}`"
                        >
                            <ReqProvince
                                :req="req"
                                :member_model="member_model"
                                :loading="loading"
                            />
                        </v-col>
                        <v-col
                            cols="12"
                            sm="4"
                            :style="`paddingLeft: ${screen_width >= 600 ? '5px' : 0}`"
                        >
                            <ReqCities
                                :req="req"
                                :member_model="member_model"
                                :loading="loading"
                            />
                        </v-col>
                    </v-row>
                </v-expand-transition>
                <ReqFacilities
                    :req="req"
                    :member_model="member_model"
                    :loading="loading"
                />
                <div v-if="req.hospClinType === 'C' || String(req.decking).toUpperCase() === 'D' || String(req.decking).toUpperCase() === 'U'">
                    <div v-if="!disableElementsReq && (typeof req.facility == 'object')">
                        <b><i>For this provider, you may leave the doctor's name blank if they are not on the list.</i></b>
                    </div>
                </div>
                <div v-else>
                    <div v-if="!disableElementsReq && (typeof req.facility == 'object')">
                        <b><i>For this provider, you may only select a doctor that is on the list.</i></b>
                    </div>
                </div>
            </v-card>
            <v-card
                :ripple="false"
                style="padding: 10px 20px; margin-top: 5px;"
                class="elevation-10"
                @click="enableHintOnReqDoc()"
            >
                <v-expand-transition>
                    <div v-show="req.hint.doc">
                        <v-alert
                            dense
                            text
                            outlined
                            style="margin: 5px"
                            color="#125C99"
                            type="info"
                        >
                            Please select a hospital before choosing a doctor
                        </v-alert>
                    </div>
                </v-expand-transition>
                <ReqFilterDoc
                    :req="req"
                    :disable-elements-req="disableElementsReq"
                    :loading="loading"
                />
                <ReqSpecField :req="req" />
                <div v-if="req.hospClinType === 'C' || String(req.decking).toUpperCase() === 'D' || String(req.decking).toUpperCase() === 'U'">
                    <ReqHospClinDoctor
                        :req="req"
                        :disable-elements-req="disableElementsReq"
                        :loading="loading"
                    />
                </div>
                <div v-else>
                    <ReqHospClinDoctor2
                        :req="req"
                        :disable-elements-req="disableElementsReq"
                        :loading="loading"
                    />
                </div>
            </v-card>
        </template>
    </FormCard>
</template>

<script>
import FormCard from './Other/FormCard.vue'
import ReqFilterHosp from './Input/Req/FilterHosp.vue'
import ReqRegion from './Input/Req/Region.vue'
import ReqProvince from './Input/Req/Province.vue'
import ReqCities from './Input/Req/Cities.vue'
import ReqFacilities from './Input/Req/Facilities.vue'
import ReqFilterDoc from './Input/Req/FilterDoc.vue'
import ReqSpecField from './Input/Req/SpecField.vue'
import ReqHospClinDoctor from './Input/Req/HospClinDoctor.vue'
import ReqHospClinDoctor2 from './Input/Req/HospClinDoctor2.vue'

export default {
    components: {
        FormCard,
        ReqFilterHosp,
        ReqRegion,
        ReqProvince,
        ReqCities,
        ReqFacilities,
        ReqFilterDoc,
        ReqSpecField,
        ReqHospClinDoctor,
        ReqHospClinDoctor2
    },
    props: ['req', 'member_model', 'screen_width', 'loading'],
    computed: {
        disableElementsReq() {
            return this.req.facility === '' || this.req.facility === null || this.req.facility && this.req.facility.hosp_msu_code && this.req.facility.hosp_msu_code === ''
        }
    },
    watch: {
        'req.hint.doc'(newVal) {
            if (newVal) {
                setTimeout(()=>{
                    this.req.hint.doc = false
                }, 4000)
            }
        }
    },
    methods: {
        enableHintOnReqDoc() {
            this.req.hint.doc = this.disableElementsReq
        }
    }
}
</script>
